//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthClient {
    constructor(private token: string) {
    }

    transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
        options.mode = 'cors';
        if (options.headers && this.token) {
            options.headers = {
                Authorization: `Bearer ${this.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }

        return Promise.resolve(options);
    }
}

export class AuthorizedApiBase {

    protected constructor(private authClient: AuthClient) {
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        return this.authClient ? this.authClient.transformHttpRequestOptions(options) : Promise.resolve(options);
    };
}

export class VehicleInfoApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<Manufacturer[]> {
        let url_ = this.baseUrl + "/api/v1/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Manufacturer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Manufacturer[];
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Manufacturer[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllRelevancies(): Promise<ManufacturerRelevancy[]> {
        let url_ = this.baseUrl + "/api/v1/manufacturers/relevancies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllRelevancies(_response);
        });
    }

    protected processGetAllRelevancies(response: Response): Promise<ManufacturerRelevancy[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManufacturerRelevancy[];
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManufacturerRelevancy[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllTyped(): Promise<TypedManufacturers[]> {
        let url_ = this.baseUrl + "/api/v1/manufacturers/bytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTyped(_response);
        });
    }

    protected processGetAllTyped(response: Response): Promise<TypedManufacturers[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TypedManufacturers[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypedManufacturers[]>(null as any);
    }

    /**
     * @return Success
     */
    getByType(vehicleType: VehicleType): Promise<TypedManufacturers> {
        let url_ = this.baseUrl + "/api/v1/manufacturers/bytype/{vehicleType}";
        if (vehicleType === undefined || vehicleType === null)
            throw new Error("The parameter 'vehicleType' must be defined.");
        url_ = url_.replace("{vehicleType}", encodeURIComponent("" + vehicleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByType(_response);
        });
    }

    protected processGetByType(response: Response): Promise<TypedManufacturers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TypedManufacturers;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypedManufacturers>(null as any);
    }

    /**
     * Gets the available VehicleInfo.Business.VehicleData for a vehicle in a specified country.
     * @param countryCode Two digit ISO 3166-2 country code for vehicle origin, e.g. SE or FI.
     * @param registrationNumber (optional) License plate text.
     * @param vehicleType (optional) Type of vehicle, e.g. Car, Moped, Tractor etc. Is required for Finland.
     * @return Success
     */
    getExtendedVehicleDataByRegistrationNumber(countryCode: string, registrationNumber: string | undefined, vehicleType: VehicleType | undefined): Promise<VehicleDataExtended> {
        let url_ = this.baseUrl + "/api/v1/vehicledataextended/{countryCode}?";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (vehicleType === null)
            throw new Error("The parameter 'vehicleType' cannot be null.");
        else if (vehicleType !== undefined)
            url_ += "vehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExtendedVehicleDataByRegistrationNumber(_response);
        });
    }

    protected processGetExtendedVehicleDataByRegistrationNumber(response: Response): Promise<VehicleDataExtended> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VehicleDataExtended;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDataExtended>(null as any);
    }

    /**
     * Gets the available VehicleInfo.Business.VehicleData for a vehicle in a specified country.
     * @param countryCode Two digit ISO 3166-2 country code for vehicle origin, e.g. SE or FI.
     * @param registrationNumber (optional) License plate text.
     * @param vehicleType (optional) Type of vehicle, e.g. Car, Moped, Tractor etc. Is required for Finland.
     * @param includeInsuranceBrand (optional) If true then InsuranceBrand in the response will be filled from core systems
     * @return Success
     */
    getByRegistrationNumber(countryCode: string, registrationNumber: string | undefined, vehicleType: VehicleType | undefined, includeInsuranceBrand: boolean | undefined): Promise<VehicleDataResponse> {
        let url_ = this.baseUrl + "/api/v1/vehicles/{countryCode}?";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (vehicleType === null)
            throw new Error("The parameter 'vehicleType' cannot be null.");
        else if (vehicleType !== undefined)
            url_ += "vehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        if (includeInsuranceBrand === null)
            throw new Error("The parameter 'includeInsuranceBrand' cannot be null.");
        else if (includeInsuranceBrand !== undefined)
            url_ += "includeInsuranceBrand=" + encodeURIComponent("" + includeInsuranceBrand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByRegistrationNumber(_response);
        });
    }

    protected processGetByRegistrationNumber(response: Response): Promise<VehicleDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VehicleDataResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDataResponse>(null as any);
    }
}

export interface Axel {
    location?: number;
    steering?: boolean;
    driven?: boolean;
    massUpLifted?: number;
    allowedTechMaxMass?: number;
    doubleTires?: boolean | undefined;
    tires?: Tire[] | undefined;
}

export enum BodyType {
    Unspecified = "Unspecified",
    LorryBA = "LorryBA",
    VanBB = "VanBB",
    SaloonAA = "SaloonAA",
    HatchbackAB = "HatchbackAB",
    StationWagonAC = "StationWagonAC",
    CoupéAD = "CoupéAD",
    ConvertibleAE = "ConvertibleAE",
    MultiPurposeVehicleAF = "MultiPurposeVehicleAF",
    SemiTrailerTractorBC = "SemiTrailerTractorBC",
    TowingVehicleForTrailerBD = "TowingVehicleForTrailerBD",
    SingleDeckCA = "SingleDeckCA",
    DoubleDeckCB = "DoubleDeckCB",
    ArticulatedSingleDeckCC = "ArticulatedSingleDeckCC",
    ArticulatedDoubleDeckCD = "ArticulatedDoubleDeckCD",
    LowFloorSingleDeckCE = "LowFloorSingleDeckCE",
    LowFloorDoubleDeckCF = "LowFloorDoubleDeckCF",
    ArticulatedLowFloorSingleDeckCG = "ArticulatedLowFloorSingleDeckCG",
    ArticulatedLowFloorDoubleDeckCH = "ArticulatedLowFloorDoubleDeckCH",
    SingleDeckCI = "SingleDeckCI",
    DoubleDeckCJ = "DoubleDeckCJ",
    ArticulatedSingleDeckCK = "ArticulatedSingleDeckCK",
    ArticulatedDoubleDeckCL = "ArticulatedDoubleDeckCL",
    LowFloorSingleDeckCM = "LowFloorSingleDeckCM",
    LowFloorDoubleDeckCN = "LowFloorDoubleDeckCN",
    ArticulatedLowFloorSingleDeckCO = "ArticulatedLowFloorSingleDeckCO",
    ArticulatedLowFloorDoubleDeckCP = "ArticulatedLowFloorDoubleDeckCP",
    SingleDeckCQ = "SingleDeckCQ",
    DoubleDeckCR = "DoubleDeckCR",
    ArticulatedSingleDeckCS = "ArticulatedSingleDeckCS",
    ArticulatedDoubleDeckCT = "ArticulatedDoubleDeckCT",
    SingleDeckCU = "SingleDeckCU",
    LowFloorSingleDeckCV = "LowFloorSingleDeckCV",
    SingleDeckCW = "SingleDeckCW",
    SemiTrailerDA = "SemiTrailerDA",
    TrailerDB = "TrailerDB",
    CentreAxleTrailerDC = "CentreAxleTrailerDC",
    MotorCaravanSA = "MotorCaravanSA",
    ArmouredVehicleSB = "ArmouredVehicleSB",
    AmbulanceSC = "AmbulanceSC",
    HearseSD = "HearseSD",
    CaravanSE = "CaravanSE",
    MobileCraneSF = "MobileCraneSF",
    OtherSpecialPurposeVehiclesSG = "OtherSpecialPurposeVehiclesSG",
    WheelchairAccessibleVehicleSH = "WheelchairAccessibleVehicleSH",
    SedanConvertible = "SedanConvertible",
    TavarafarmariAG = "TavarafarmariAG",
    LinjaAutonAlustaCX = "LinjaAutonAlustaCX",
    AvopakettiautoBE = "AvopakettiautoBE",
    AlustaOhjaamoBX = "AlustaOhjaamoBX",
    NivelöimättömälläVetoaisallaVarustettuPerävaunuDE = "NivelöimättömälläVetoaisallaVarustettuPerävaunuDE",
    ApuvaunuSJ = "ApuvaunuSJ",
    ErikoiskuljetusperävaunuSK = "ErikoiskuljetusperävaunuSK",
    AvokattoinenYksikerroksinenAjoneuvoCI = "AvokattoinenYksikerroksinenAjoneuvoCI",
    TavaraAutoBA = "TavaraAutoBA",
    AvokattoinenLaksikerroksinenAjoneuvoCJ = "AvokattoinenLaksikerroksinenAjoneuvoCJ",
    ExceptionalLoadTransportTrailer = "ExceptionalLoadTransportTrailer",
    ExceptionalLoadTransportMotorVehicle = "ExceptionalLoadTransportMotorVehicle",
    MultiEquipmentCarrier = "MultiEquipmentCarrier",
}

export enum ConstraintType {
    Unspecified = "Unspecified",
    Alterationprohibition = "Alterationprohibition",
    Pending = "Pending",
    Drivingban = "Drivingban",
    Vehicletaxexemption = "Vehicletaxexemption",
    Salesrestriction = "Salesrestriction",
    Monitoringinspectionobligation = "Monitoringinspectionobligation",
    Monitoringinspectionobligationneglected = "Monitoringinspectionobligationneglected",
    Alterationinspectionobligation = "Alterationinspectionobligation",
    Recall = "Recall",
    Annualvehicleinspectionnotperformed = "Annualvehicleinspectionnotperformed",
    VehicleStolen = "VehicleStolen",
    Licenseplatesstolen = "Licenseplatesstolen",
    AlterationBan13 = "AlterationBan13",
    AlterationBan14 = "AlterationBan14",
    Pendingdata = "Pendingdata",
    Mortgagedata = "Mortgagedata",
    Insuranceunpaiddata = "Insuranceunpaiddata",
    Vehicledecommissioning = "Vehicledecommissioning",
    Finalderegistration = "Finalderegistration",
    Deregistration = "Deregistration",
    Validexportregistration = "Validexportregistration",
    Vehicletaxoverdue = "Vehicletaxoverdue",
    Vehicletaxsurtaxoverdue = "Vehicletaxsurtaxoverdue",
    OldvehicletaxOrDieseltaxoverdue = "OldvehicletaxOrDieseltaxoverdue",
    Licenseplatesrepossessed = "Licenseplatesrepossessed",
    Vehicletaxrefunded = "Vehicletaxrefunded",
    Othernote = "Othernote",
    Ordinarynote = "Ordinarynote",
    PeriodofNonUse = "PeriodofNonUse",
    Licenseplatesreturned = "Licenseplatesreturned",
    Licenseplatesstored = "Licenseplatesstored",
    Additionalplate = "Additionalplate",
    Notificationofselling = "Notificationofselling",
    Drivingbanduetolicenseplaterepossession = "Drivingbanduetolicenseplaterepossession",
    Inspectionvalidthroughdate = "Inspectionvalidthroughdate",
    Additionaltaxpending = "Additionaltaxpending",
    Vehicletaxhasfallendue = "Vehicletaxhasfallendue",
    Transferremark = "Transferremark",
    Returnofforeignplates = "Returnofforeignplates",
    InsuranceRegistrationneglected = "InsuranceRegistrationneglected",
}

export interface Constraints {
    constraintType?: ConstraintType;
    priority?: number;
    constraintStartDate?: Date | undefined;
    constraintEndDate?: Date | undefined;
}

export enum ConsumptionType {
    Unspecified = "Unspecified",
    FuelConsumptionRoad = "FuelConsumptionRoad",
    FuelConsumptionUrban = "FuelConsumptionUrban",
    CombinedConsumption = "CombinedConsumption",
    CO2Combined = "CO2Combined",
    CO2Urban = "CO2Urban",
    CO2Road = "CO2Road",
    CO2CombinedWeighted = "CO2CombinedWeighted",
    ConsumptionCombinedWeighted = "ConsumptionCombinedWeighted",
    WLTPCO2Weighted = "WLTPCO2Weighted",
    WLTPCO2CombinedWeighted = "WLTPCO2CombinedWeighted",
    WLTPIConsumptionCombined = "WLTPIConsumptionCombined",
    WLTPIConsumptionCombinedWeighted = "WLTPIConsumptionCombinedWeighted",
}

export interface Customer {
    customerType?: CustomerType;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    startDate?: Date | undefined;
    ownershipType?: OwnershipType;
    /** TransferRestriction is used to inform claims technicians
that some customer data might be restricted */
    transferRestriction?: number;
    /** Date of death of customer */
    passingDate?: string | undefined;
}

export enum CustomerType {
    Unspecified = "Unspecified",
    FirstOwner = "FirstOwner",
    OtherOwner = "OtherOwner",
    FirstOperator = "FirstOperator",
    OtherOperator = "OtherOperator",
    InterimOwner = "InterimOwner",
    Reseller = "Reseller",
    Recipient = "Recipient",
    FormerOwner = "FormerOwner",
    FormerOperator = "FormerOperator",
}

export enum ElectricType {
    Unspecified = "Unspecified",
    None = "None",
    Electric = "Electric",
    Hybrid = "Hybrid",
    PluginHybrid = "PluginHybrid",
}

export interface Emission {
    consumptionType?: ConsumptionType;
    quantity?: number;
}

export interface FuelTank {
    volume?: number | undefined;
    material?: string | undefined;
    additionalContainer?: boolean | undefined;
}

export enum FuelType {
    Unspecified = "Unspecified",
    Petrol = "Petrol",
    Diesel = "Diesel",
    Electric = "Electric",
    Kerosene = "Kerosene",
    GeneratorGas = "GeneratorGas",
    Etanol = "Etanol",
    MotorGas = "MotorGas",
    Methane = "Methane",
    HydrogenGas = "HydrogenGas",
    Other = "Other",
    Biodiesel = "Biodiesel",
}

export enum FuelTypeFI {
    Petrol = "Petrol",
    Diesel = "Diesel",
    FuelOil = "FuelOil",
    Electricity = "Electricity",
    Hydrogen = "Hydrogen",
    Gas = "Gas",
    Methanol = "Methanol",
    Biodiesel = "Biodiesel",
    LPG = "LPG",
    CNG = "CNG",
    Kerosene = "Kerosene",
    DieselWood = "DieselWood",
    BensiiniPuu = "BensiiniPuu",
    PetrolKerosene = "PetrolKerosene",
    Ethanol = "Ethanol",
    PetrolCNG = "PetrolCNG",
    PetrolElectricity = "PetrolElectricity",
    PetrolEthanol = "PetrolEthanol",
    PetrolMethanol = "PetrolMethanol",
    PetrolLPG = "PetrolLPG",
    DieselCNG = "DieselCNG",
    DieselElectricity = "DieselElectricity",
    DieselEthanol = "DieselEthanol",
    DieselMethanol = "DieselMethanol",
    DieselLPG = "DieselLPG",
    DieselBiodiesel = "DieselBiodiesel",
    DieselBiodieselElectricity = "DieselBiodieselElectricity",
    DieselBiodieselEthanol = "DieselBiodieselEthanol",
    DieselBiodieselMethanol = "DieselBiodieselMethanol",
    DieselBiodieselLPG = "DieselBiodieselLPG",
    DieselBiodieselCNG = "DieselBiodieselCNG",
    HydrogenElectricity = "HydrogenElectricity",
    DieselOther = "DieselOther",
    NaturalGasTypeH = "NaturalGasTypeH",
    NaturalGasTypeL = "NaturalGasTypeL",
    NaturalGasTypeHL = "NaturalGasTypeHL",
    NaturalGasBiomethane = "NaturalGasBiomethane",
    Biomethan = "Biomethan",
    Wood = "Wood",
    EthanolED95 = "EthanolED95",
    EthanolE85 = "EthanolE85",
    H2NG = "H2NG",
    LNG = "LNG",
    LNG20 = "LNG20",
    DieselLNG = "DieselLNG",
    DieselLNG20 = "DieselLNG20",
    Mixture = "Mixture",
    Unspecified = "Unspecified",
    Other = "Other",
}

export enum GearBoxType {
    Unknown = "Unknown",
    Manual = "Manual",
    Automatic = "Automatic",
    ManualAddon = "ManualAddon",
    AutomaticAddon = "AutomaticAddon",
    Variomatic = "Variomatic",
    VariableTransmission = "VariableTransmission",
    FootTransmission = "FootTransmission",
    NotAvailable = "NotAvailable",
    Other = "Other",
}

export enum HybridType {
    Unspecified = "Unspecified",
    PlugInHybrid = "PlugInHybrid",
    OnlyCombustionEngineCharge = "OnlyCombustionEngineCharge",
    PlugInFuelCellHybrid = "PlugInFuelCellHybrid",
    FuelCellHybrid = "FuelCellHybrid",
}

export enum ImportedVehicleType {
    Unspecified = "Unspecified",
    BroughtInUsed = "BroughtInUsed",
    BroughtInNew = "BroughtInNew",
}

export enum InspectionDecisionType {
    Unspecified = "Unspecified",
    Interrupted = "Interrupted",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Annulled = "Annulled",
}

export interface LastMileageInfo {
    lastMileage?: number;
    lastMileageDate?: Date | undefined;
    hasFiveDigitMeter?: boolean | undefined;
    hasMileageAsMiles?: boolean | undefined;
    hasNoMeter?: boolean | undefined;
}

export enum MandatoryType {
    Unspecified = "Unspecified",
    Compulsory = "Compulsory",
    OptionalInstalled = "OptionalInstalled",
    OtherDeclared = "OtherDeclared",
}

export interface Manufacturer {
    /** National manufacturer code (for ex. from swedish VTR) */
    code: string;
    /** International, global and unique to Partner Directory manufacturer code */
    internationalManufacturerCode: string;
    /** Two letter country code of this manufacturer */
    countryCode: string;
    /** Name of the manufacturer, e.g. Audi. */
    name: string;
}

export interface ManufacturerRelevancy {
    manufacturerCode: string;
    vehicleType: VehicleType;
    /** This manufacturer can be used in ratings for Sweden */
    se: boolean;
    /** This manufacturer can be used in ratings for Finland */
    fi: boolean;
    /** This manufacturer can be used in ratings for Norway */
    no: boolean;
}

export enum OwnershipType {
    Unspecified = "Unspecified",
    Leasing = "Leasing",
    CompanyVehicle = "CompanyVehicle",
    OtherDeclared = "OtherDeclared",
}

export interface Part {
    name?: string | undefined;
    foundPercentage?: number;
}

export interface SafetyEquipment {
    safetyType?: SafetyType;
    seatRow?: number;
    location?: string | undefined;
    mandatory?: MandatoryType;
}

export enum SafetyType {
    Unspecified = "Unspecified",
    CrashActiveNeckRest = "CrashActiveNeckRest",
    FrontAirbag = "FrontAirbag",
    SideAirbag = "SideAirbag",
    SeatBeltTensioner = "SeatBeltTensioner",
}

export interface Tire {
    location?: number;
    tireSize?: string | undefined;
    wheelSize?: string | undefined;
    offset?: string | undefined;
    loadAndSpeedClass?: string | undefined;
}

/** Manufacurers for a specific VehicleInfo.Business.TypedManufacturers.VehicleType */
export interface TypedManufacturers {
    vehicleType?: VehicleType;
    /** List of manufacturers for the specified VehicleInfo.Business.TypedManufacturers.VehicleType */
    manufacturers?: Manufacturer[] | undefined;
}

export enum UseOfVehicleType {
    Unspecified = "Unspecified",
    Private = "Private",
    SubjectToPermit = "SubjectToPermit",
    School = "School",
    Rental = "Rental",
    SalesWarehouse = "SalesWarehouse",
    LicensedFreightTransport = "LicensedFreightTransport",
}

export interface ValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    readonly errors?: { [key: string]: string[]; } | undefined;
}

export enum VehicleCategoryType {
    Unspecified = "Unspecified",
    Car = "Car",
    Tractor = "Tractor",
    LightQuadricycle = "LightQuadricycle",
    Moped = "Moped",
    Motorcycle = "Motorcycle",
    MotorTricycleOrQuadricycle = "MotorTricycleOrQuadricycle",
    MotorTricycle = "MotorTricycle",
    Quadricycle = "Quadricycle",
    TractorRegisteredForRoadUse = "TractorRegisteredForRoadUse",
    Bus = "Bus",
    AllTerrainVehicle = "AllTerrainVehicle",
    PublicWorksVehicle = "PublicWorksVehicle",
    OTHER = "OTHER",
    Van = "Van",
    Lorry = "Lorry",
    LightTrailer = "LightTrailer",
    Trailer = "Trailer",
    TractorTrailer = "TractorTrailer",
    TowedMachinery = "TowedMachinery",
}

export enum VehicleColor {
    Unknown = "Unknown",
    White = "White",
    Black = "Black",
    Grey = "Grey",
    Red = "Red",
    Blue = "Blue",
    Silver = "Silver",
    Green = "Green",
    Brown = "Brown",
    Yellow = "Yellow",
    Orange = "Orange",
    Purple = "Purple",
    MultiColor = "MultiColor",
    LightGrey = "LightGrey",
    DarkGrey = "DarkGrey",
    LightRed = "LightRed",
    DarkRed = "DarkRed",
    LightBlue = "LightBlue",
    DarkBlue = "DarkBlue",
    LightBrown = "LightBrown",
    DarkBrown = "DarkBrown",
    LightGreen = "LightGreen",
    DarkGreen = "DarkGreen",
    LightYellow = "LightYellow",
    Missing = "Missing",
    Beige = "Beige",
    Gold = "Gold",
    Pink = "Pink",
    Violet = "Violet",
    Turquoise = "Turquoise",
    Metallic = "Metallic",
    Light = "Light",
    Dark = "Dark",
}

export interface VehicleDataExtended {
    /** Two digit ISO 3166-2 code, e.g SE, DK, FI or NO. */
    countryCode: string;
    /** Licence plate number. */
    registrationNumber: string;
    /** Vehicle Identification Number (VIN). */
    identificationNumber?: string | undefined;
    /** Name of the manufacturer, e.g. Audi. */
    manufacturer?: string | undefined;
    /** National manufacturer code */
    manufacturerCode?: string | undefined;
    /** Manufacturer code, internal to Partner Directory */
    internationalManufacturerCode?: string | undefined;
    /** Vehicle model, e.g. PASSAT, A6 or V90. */
    model?: string | undefined;
    /** Model year of the vehicle. */
    vehicleYear?: number | undefined;
    /** Acquisition date for the current owner. */
    acquisitionDate?: Date | undefined;
    vehicleType?: VehicleType;
    /** EU vehicle category, ex: 'M1', 'N1', 'L1e' or 'L3e-A3'. */
    vehicleCategory?: string | undefined;
    electricType?: ElectricType;
    fuelType?: FuelType;
    /** First registration date in the country. */
    firstRegistrationDate?: Date | undefined;
    vehicleColor?: VehicleColor;
    status?: VehicleStatus;
    /** Last date the VehicleInfo.Business.VehicleData.Status was changed. */
    statusDate?: Date | undefined;
    gearBox?: GearBoxType;
    /** Height in millimeter. */
    height?: number | undefined;
    /** Length in millimeter. */
    length?: number | undefined;
    /** Width in millimeter. */
    width?: number | undefined;
    /** Kerb weight (tjänstevikt/actual weight) in kg. */
    kerbWeight?: number | undefined;
    /** Total weight in kg. */
    totalWeight?: number | undefined;
    /** Max speed in km/h. */
    maxSpeed?: number | undefined;
    /** Engine power in kW. */
    enginePower?: number | undefined;
    /** Cylinder size in cubic centimeters (cm³). */
    cylinderCapacity?: number | undefined;
    /** Does the current user lease the vehicle. */
    isLeasing?: boolean | undefined;
    /** Is the vehicle bought on credit. */
    hasCredit?: boolean | undefined;
    isDirectImported?: boolean | undefined;
    isFourWheelDrive?: boolean | undefined;
    /** Max number of passengers except driver. */
    maxPassengers?: number | undefined;
    /** Mileage in kilometer (aka körsträcka). */
    odometer?: number | undefined;
    /** Date when the record in database was modified. */
    modifiedDate?: Date;
    /** Previous License Plate Number */
    previousRegistrationNumber?: string | undefined;
    /** Sub Model */
    submodel?: string | undefined;
    /** Engine Volume */
    engineVolume?: number | undefined;
    /** Engine power in kW with decimals. */
    enginePowerDecimal?: number | undefined;
    /** Number Of Cylinders */
    numberOfCylinders?: number | undefined;
    /** Number Of Gears */
    numberOfGears?: number | undefined;
    /** Number Of Seats */
    numberOfSeats?: number | undefined;
    /** Date of Registration for vehicle (not formatted) */
    registrationDate?: string | undefined;
    /** Date of Inspection */
    inspectionDate?: Date | undefined;
    inspectionDecision?: InspectionDecisionType;
    /** First Date for Vehicle Inspection */
    inspectionTimeFrom?: Date | undefined;
    /** Last Date for Vehicle Inspection */
    inspectionTimeTo?: Date | undefined;
    /** Date for Inspection Change */
    inspectionChange?: Date | undefined;
    /** Number Of Replaced Parts */
    numberOfReplacedParts?: number | undefined;
    importedVehicleType?: ImportedVehicleType;
    /** Country of origin for Import */
    importedCountry?: string | undefined;
    /** List of Customers/Owners */
    customers?: Customer[] | undefined;
    /** List of Axels */
    axels?: Axel[] | undefined;
    /** Sub Model, e.g. SPORTAGE */
    insuranceCompany?: string | undefined;
    /** Sub Model, e.g. SPORTAGE */
    insuranceStartDate?: Date | undefined;
    /** Name of Policy Holder */
    policyHolderName?: string | undefined;
    /** Policy Holder SSN */
    policyHolderSSN?: string | undefined;
    vehicleColor2?: VehicleColor;
    bodyType?: BodyType;
    /** Number Of Axels */
    numberOfAxels?: number | undefined;
    /** List of Emission Info */
    emission?: Emission[] | undefined;
    /** List of Constraints */
    constraints?: Constraints[] | undefined;
    /** List of difference parts */
    differenceParts?: Part[] | undefined;
    useOfVehicleType?: UseOfVehicleType;
    /** List of Safety Equipment */
    safetyEquipment?: SafetyEquipment[] | undefined;
    fuelTank?: FuelTank;
    /** Turbocharger */
    turbocharger?: boolean | undefined;
    /** Intercooler */
    intercooler?: boolean | undefined;
    /** TankCapacity */
    tankCapacity?: number | undefined;
    fuelTypeFI?: FuelTypeFI;
    vehicleCategoryType?: VehicleCategoryType;
    hybridType?: HybridType;
    /** Power of Electric Motor */
    electricMotorPower?: number | undefined;
    lastMileageInfo?: LastMileageInfo;
}

export interface VehicleDataResponse {
    /** Two digit ISO 3166-2 code, e.g SE, DK, FI or NO. */
    countryCode: string;
    /** Licence plate number. */
    registrationNumber: string;
    /** Vehicle Identification Number (VIN). */
    identificationNumber?: string | undefined;
    /** Name of the manufacturer, e.g. Audi. */
    manufacturer?: string | undefined;
    /** National manufacturer code */
    manufacturerCode?: string | undefined;
    /** Manufacturer code, internal to Partner Directory */
    internationalManufacturerCode?: string | undefined;
    /** Vehicle model, e.g. PASSAT, A6 or V90. */
    model?: string | undefined;
    /** Model year of the vehicle. */
    vehicleYear?: number | undefined;
    /** Acquisition date for the current owner. */
    acquisitionDate?: Date | undefined;
    vehicleType?: VehicleType;
    /** EU vehicle category, ex: 'M1', 'N1', 'L1e' or 'L3e-A3'. */
    vehicleCategory?: string | undefined;
    electricType?: ElectricType;
    fuelType?: FuelType;
    /** First registration date in the country. */
    firstRegistrationDate?: Date | undefined;
    vehicleColor?: VehicleColor;
    status?: VehicleStatus;
    /** Last date the VehicleInfo.Business.VehicleData.Status was changed. */
    statusDate?: Date | undefined;
    gearBox?: GearBoxType;
    /** Height in millimeter. */
    height?: number | undefined;
    /** Length in millimeter. */
    length?: number | undefined;
    /** Width in millimeter. */
    width?: number | undefined;
    /** Kerb weight (tjänstevikt/actual weight) in kg. */
    kerbWeight?: number | undefined;
    /** Total weight in kg. */
    totalWeight?: number | undefined;
    /** Max speed in km/h. */
    maxSpeed?: number | undefined;
    /** Engine power in kW. */
    enginePower?: number | undefined;
    /** Cylinder size in cubic centimeters (cm³). */
    cylinderCapacity?: number | undefined;
    /** Does the current user lease the vehicle. */
    isLeasing?: boolean | undefined;
    /** Is the vehicle bought on credit. */
    hasCredit?: boolean | undefined;
    isDirectImported?: boolean | undefined;
    isFourWheelDrive?: boolean | undefined;
    /** Max number of passengers except driver. */
    maxPassengers?: number | undefined;
    /** Mileage in kilometer (aka körsträcka). */
    odometer?: number | undefined;
    /** Date when the record in database was modified. */
    modifiedDate?: Date;
    /** Insurance brand for the policy coverage of the vehicle, if available. Null if not branded. */
    insuranceBrand?: string | undefined;
}

export enum VehicleStatus {
    Unspecified = "Unspecified",
    Active = "Active",
    InActive = "InActive",
    Registered = "Registered",
    Decommissioned = "Decommissioned",
    DeregisteredTrafficDataSystem = "DeregisteredTrafficDataSystem",
    PermanentlyDeregisteredDestroyed = "PermanentlyDeregisteredDestroyed",
    TransferPermit = "TransferPermit",
    ExportRegistered = "ExportRegistered",
    InspectedForMortgage = "InspectedForMortgage",
    NotRegistered = "NotRegistered",
    AdvanceNotifiedNotRegistered = "AdvanceNotifiedNotRegistered",
    InspectedForRegistrationNotRegistered = "InspectedForRegistrationNotRegistered",
}

/** Have the vehicle types match the types in EU. https://www.transportstyrelsen.se/globalassets/global/vag/fordon/fordonsregler/fordonskategorier.xlsx. */
export enum VehicleType {
    Unspecified = "Unspecified",
    Car = "Car",
    LightTruck = "LightTruck",
    HeavyTruck = "HeavyTruck",
    LightBus = "LightBus",
    HeavyBus = "HeavyBus",
    LightTrailer = "LightTrailer",
    HeavyTrailer = "HeavyTrailer",
    Moped = "Moped",
    MopedCar = "MopedCar",
    Motorcycle = "Motorcycle",
    Tractor = "Tractor",
    Atv = "Atv",
    AtvTractor = "AtvTractor",
    Snowmobile = "Snowmobile",
    MobileHome = "MobileHome",
    Agricultural = "Agricultural",
    Construction = "Construction",
    Forestry = "Forestry",
    AuxiliaryEquipment = "AuxiliaryEquipment",
    ElectricVehicle = "ElectricVehicle",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}